import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "cart-item-controls" };
const _hoisted_2 = { class: "cart-item-controls__quantity" };
const _hoisted_3 = {
    key: 0,
    class: "cart-item-controls__unit"
};
const _hoisted_4 = { class: "cart-item-controls__price" };
const _hoisted_5 = { class: "cart-item-controls__actions" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = ["title"];
import { onMounted, ref, watch } from 'vue';
import productUtils from "@astina/paloma-shop-common-ui/src/services/ProductUtils";
import Price from "@astina/paloma-shop-common-ui/src/components/Price.vue";
import ArticleQuantityInput from "@astina/paloma-shop-common-ui/src/components/ArticleQuantityInput.vue";
import ArticleParametersForm from "@astina/paloma-shop-common-ui/src/components/ArticleParametersForm.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartItemControls',
    props: {
        item: {},
        taxIncluded: { type: Boolean }
    },
    emits: [
        'item-quantity-change',
        'item-remove',
        'item-params-change'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const quantityConfig = ref(null);
        const hasParameters = ref(false);
        const showParametersForm = ref(false);
        onMounted(() => {
            onItemQuantityChange();
            onItemParamsChange();
        });
        function onQuantityChange(quantity) {
            if (props.item.quantity === quantity.quantity && props.item.portions === quantity.portions) {
                return;
            }
            emit('item-quantity-change', quantity);
        }
        function pricingAmount(pricing) {
            return props.taxIncluded
                ? pricing.grossPriceFormatted
                : pricing.netPriceFormatted;
        }
        function removeCartItem() {
            emit('item-remove');
        }
        watch(() => props.item.quantity, onItemQuantityChange);
        watch(() => props.item.portions, onItemQuantityChange);
        function onItemQuantityChange() {
            const orderingUnit = props.item.variant.orderingUnits
                .find(ou => ou.unitCode === props.item.unitCode)
                || productUtils.createOrderingUnitForCartItem(props.item);
            quantityConfig.value = productUtils.createQuantityConfig(props.item.quantity, props.item.variant, orderingUnit, props.item.portions);
        }
        watch(() => props.item.parameters, onItemParamsChange);
        function onItemParamsChange() {
            hasParameters.value = props.item.variant.parameters
                && JSON.stringify(props.item.variant.parameters) !== '{}' || false;
        }
        function onSubmitParameters(params) {
            showParametersForm.value = false;
            emit('item-params-change', params);
        }
        function onCancelParameters() {
            showParametersForm.value = false;
        }
        function hasItemParameters() {
            return props.item.parameters && props.item.parameters.length > 0;
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (quantityConfig.value)
                        ? (_openBlock(), _createBlock(ArticleQuantityInput, {
                            key: 0,
                            ref: "article-quantity-input",
                            available: true,
                            config: quantityConfig.value,
                            "reset-on-cart-item-added": false,
                            "reset-portions-on-close": false,
                            sku: __props.item.sku,
                            "quantity-is-reserved": true,
                            "display-portions": "top",
                            onChange: onQuantityChange
                        }, null, 8, ["config", "sku"]))
                        : _createCommentVNode("", true)
                ]),
                _cache[3] || (_cache[3] = _createTextVNode()),
                (__props.item.unitCode !== 'piece')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$unit(__props.item)), 1))
                    : _createCommentVNode("", true),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(Price, {
                        currency: __props.item.itemPricing.currency,
                        amount: pricingAmount(__props.item.itemPricing)
                    }, null, 8, ["currency", "amount"])
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createElementVNode("div", _hoisted_5, [
                    (_ctx.$isGranted('ROLE_PERM_ORDERS_CREATE') && hasParameters.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                            _createElementVNode("a", {
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (showParametersForm.value = true), ["prevent"])),
                                href: "",
                                class: "cart-item-controls__action"
                            }, [
                                _createVNode(_component_icon, {
                                    name: "comment",
                                    "icon-style": hasItemParameters() ? 'solid' : 'regular'
                                }, null, 8, ["icon-style"])
                            ]),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            (showParametersForm.value)
                                ? (_openBlock(), _createBlock(ArticleParametersForm, {
                                    key: 0,
                                    variant: __props.item.variant,
                                    params: __props.item.parameters,
                                    onSubmit: onSubmitParameters,
                                    onCancel: onCancelParameters
                                }, null, 8, ["variant", "params"]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("a", {
                        onClick: _withModifiers(removeCartItem, ["prevent"]),
                        title: _ctx.$t('cart.remove_item'),
                        class: "cart-item-controls__action",
                        href: ""
                    }, [
                        _createVNode(_component_icon, {
                            name: "trash-alt",
                            "icon-style": "light"
                        })
                    ], 8, _hoisted_7)
                ])
            ]));
        };
    }
});
